import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Section from "../../components/Section";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import SuccessProcess from '../../components/Notifications/SuccessProcess';
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import InfoNotification from "../../components/Notifications/InfoNotification";
import Loader from "../../components/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faRotate, faCircleArrowLeft, faXmark } from "@fortawesome/free-solid-svg-icons";
import apiClient from "../../axios";

const ProductTypeFrom = ({ handleLogout }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [code, setCode] = useState("");
    const [description, setDescription] = useState("");
    const [contractType, setContractType] = useState([]);
    const [contractTypeId, setContractTypeId] = useState("");
    const [isPack, setIsPack] = useState(0);
    const [flagActive, setCheckObservacion] = useState(0);
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [errorsMessage, setErrorMessage] = useState({});
    const [isLoginVisible, setIsLoginVisible] = useState(false);
    const [errors, setErrors] = useState({});
    const [isInfoVisible, setIsInfoVisible] = useState(false);
    const [infoPayload, setInfoPayload] = useState({});
    const [notificationBlock, setNotificationBlock] = useState(false);
    const [messageBlock, setMessageBlock] = useState(false);

    useEffect(() => {
        if (id) {
            const fetchProductType = async () => {
                try {
                    setLoading(true);
                    const response = await apiClient.get(`/product_type/${id}`);
                    setCode(response.data.code);
                    setDescription(response.data.description);
                    setContractTypeId(response.data.contractTypeId);
                    setIsPack(response.data.isPack ? 1 : 0);
                    setCheckObservacion(response.data.flagActive ? 1 : 0);
                } catch (error) {
                    console.error("Error al cargar el tipo de contrato", error);
                } finally {
                    setLoading(false);
                }
            };
            fetchProductType();
        }
        const fetchContractTypes = async () => {
            try {
                setLoading(true);
                const contTypes = await apiClient.get(`/contract_type`);
                if (contTypes.status === 200) {
                    setContractType(contTypes.data || []);
                }
            } catch (error) {
                console.error("Error al cargar los Tipos de Contrato", error);
            } finally {
                setLoading(false);
            }
        };
        fetchContractTypes();
    }, [id]);

    const toggleSwitchFlag = () => {
        setCheckObservacion((prev) => (prev === 1 ? 0 : 1));
    };

    const toggleSwitchPack = () => {
        setIsPack((prev) => (prev === 1 ? 0 : 1));
    };

    const handleCloseBlock = () => {
        setNotificationBlock(false);
    };
    const validateFields = () => {
        let validationErrors = {};
        if (!code) validationErrors.code = "El Campo es Obligatorio";
        if (!description) validationErrors.description = "El Campo es Obligatorio";
        if (!contractTypeId) validationErrors.contractTypeId = "El Campo es Obligatorio";
        return validationErrors;
    };

    const handleSave = async () => {
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const payload = {
            code,
            description,
            contractTypeId,
            isPack: isPack === 1,
            flagActive: flagActive === 1
        };
        const payloadUpdate = {
            description,
            contractTypeId,
            isPack: isPack === 1,
            flagActive: flagActive === 1
        };

        try {
            let response;
            setLoading(true);
            if (id) {
                response = await apiClient.patch(`/product_type/${id}`, payloadUpdate);
                if (response.status === 200) {
                    setIsSuccessVisible(true);
                    setIsErrorVisible(false);
                    setIsLoginVisible(false);
                    setErrors({});
                    navigate("/ProductTypeList");
                }
            } else {
                response = await apiClient.post("/product_type", payload);
                if (response.status === 201) {
                    setIsSuccessVisible(true);
                    setIsErrorVisible(false);
                    setErrors({});
                    navigate("/ProductTypeList");
                } else if (response.data.message === "PRODUCT_TYPE_ARCHIVED") {
                    setInfoPayload(payload);
                    setIsInfoVisible(true);
                    setIsSuccessVisible(false);
                    setIsErrorVisible(false);
                }
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsLoginVisible(true);
            } else if (error.response?.data?.message.startsWith("PRODUCT_TYPE_ALREADY_EXIST")) {
                setMessageBlock("El Tipo de Producto ya existe.");
                setNotificationBlock(true);

            } else if (error.response?.data?.message.startsWith("PRODUCT_TYPE_ARCHIVED")) {
                setInfoPayload(payload);
                setIsInfoVisible(true);
                setIsSuccessVisible(false);
                setIsErrorVisible(false);
            } else {
                setErrorMessage("¡Oops! Ocurrió un error al crear el Tipo de Producto");
                setIsLoginVisible(false);
                setIsErrorVisible(true);
                setIsSuccessVisible(false);
                setTimeout(() => {
                    setIsErrorVisible(false);
                }, 4000);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="home-container">
            <Header onLogout={handleLogout} title="Tipos de Producto" />
            <Section>
                <div className="button-return-container">
                    <FontAwesomeIcon
                        className="basic-shortcut-icon"
                        style={{ cursor: "pointer" }}
                        icon={faCircleArrowLeft}
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate("/ProductTypeList");
                        }}
                    />
                </div>
            </Section>
            <div className="moduleNew-form-container">
                <h3 className="basic-info-form-title">Información del Tipo de Producto</h3>
                <div className="basic-info-form-grid">
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.code ? "red" : "revert-layer" }}>
                            Código
                        </label>
                        <input
                            type="text"
                            placeholder="Código"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            readOnly={!!id}
                        />
                        {errors.code && <p className="error-message">{errors.code}</p>}
                    </div>

                    <div className="basic-info-form-group">
                        <label style={{ color: errors.description ? "red" : "revert-layer" }}>
                            Descripción
                        </label>
                        <input
                            type="text"
                            placeholder="Descripción"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                        {errors.description && <p className="error-message">{errors.description}</p>}
                    </div>

                    <div className="basic-info-form-group">
                        <label style={{ color: errors.contractTypeId ? "red" : "revert-layer" }}>Tipo de Contrato</label>
                        <select
                            value={contractTypeId}
                            onChange={(e) => {
                                const selectedId = e.target.value; // ID del tipo de contrato seleccionado
                                setContractTypeId(selectedId); // Guardar el ID en contractTypeId
                            }
                            }
                        >
                            <option value="">Seleccione una opción</option>
                            {contractType.map((cType) => (
                                <option key={cType.id} value={cType.id}>
                                    {cType.description}
                                </option>
                            ))}
                        </select>
                        {errors.contractTypeId && <p className="error-message">{errors.contractTypeId}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <div className="basic-info-form-switch">
                            <label>Estado</label>
                            <div className="slider-container-contract" onClick={toggleSwitchFlag}>
                                <div className={`slider-option-contract ${flagActive === 1
                                    ? "active-contract"
                                    : "inactive-contract"}`}>
                                    Activo
                                </div>
                                <div className={`slider-option-contract ${flagActive === 0
                                    ? "active-contract"
                                    : "inactive-contract"}`}>
                                    Inactivo
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="basic-info-form-group">
                        <div className="basic-info-form-switch">
                            <label>Paquete</label>
                            <div className="slider-container-contract" onClick={toggleSwitchPack}>
                                <div className={`slider-option-contract ${isPack === 1
                                    ? "active-contract"
                                    : "inactive-contract"}`}>
                                    Sí
                                </div>
                                <div className={`slider-option-contract ${isPack === 0
                                    ? "active-contract"
                                    : "inactive-contract"}`}>
                                    No
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="basic-form-footer">
                    <button
                        className="basic-custom-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate("/ProductTypeList");
                        }}
                    >
                        <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                        Cancelar
                    </button>
                    <button
                        className="basic-custom-button"
                        onClick={handleSave}
                    >
                        <FontAwesomeIcon
                            icon={id ? faRotate : faSave}
                            className="basic-shortcut-icon"
                        />
                        {id ? "Actualizar" : "Guardar"}
                    </button>
                </div>
            </div>
            <SuccessNotification
                message={
                    id
                        ? "El Tipo de Producto se ha Actualizado Correctamente."
                        : "El Tipo de Producto se ha Creado Correctamente."
                }
                isVisible={isSuccessVisible}
                onClose={() => setIsSuccessVisible(false)}
            />
            <ErrorNotification
                message={errorsMessage}
                isVisible={isErrorVisible}
                onClose={() => setIsErrorVisible(false)}
            />
            <LoginNotification
                message="Vuelve a iniciar sesión"
                isVisible={isLoginVisible}
                onClose={() => setIsLoginVisible(false)}
                onLogout={handleLogout}
            />
            <InfoNotification
                message="Tipo de Producto Archivado. ¿Desea restaurarlo?"
                isVisible={isInfoVisible}
                onClose={() => setIsInfoVisible(false)}
                payload={infoPayload}
                route={'/product_type?restore=true'}
            />
            {notificationBlock && (
                <SuccessProcess
                    enca={true}
                    message={`No se puede Crear el Tipo de Producto debido a : ${messageBlock}`}
                    isVisible={notificationBlock}
                    onClose={handleCloseBlock}
                    redirectOnOk={true}
                    pageNavigate={"/ProductTypeList"}
                    whatsApp={false} 
                />
            )}
            {loading && <Loader />}
        </div>
    );
};

export default ProductTypeFrom;
